module.exports = __webpack_public_path__ + "img/SILK[GYRI]-icon.5fe04e4.png";